<div class="datalog-component-wrapper pl-l pr-l pt-s pb-l">
  <div class="forms-container filter-datalog">
    <div class="form-field-container">
      <div class="form-container" style="margin-top: unset">
        <div class="form-field-container pr-s main-page flex-child-50">
          <polytech-ui-date-picker
            (dateChanged)="updateDateRange($event)"
            initialTimeRange="14"
            [canAlwaysConfirm]="true"
            timeZone="Africa/Abidjan"
            #datePickerRef
          >
            <dt (click)="datePickerRef.setDefinedRange('14d')">Last 14 days</dt>
            <dt (click)="datePickerRef.setDefinedRange('3m')">Last 3 months</dt>
            <dt (click)="datePickerRef.setDefinedRange('6m')">Last 6 months</dt>
            <dt (click)="selectAllData()">All Time</dt>
          </polytech-ui-date-picker>
        </div>
      </div>
    </div>
    <button mat-button class="btn-grey" ngProjectAs="buttons" (click)="openDialog()">
      <img src="/assets/icons/export.svg" />
      {{ "component.export" | translate }}
    </button>
  </div>
  <mat-card class="shadow-card">
    <div class="content">
      @if (isLoaded) { @if (dataSource.length === 0) {
      <div style="text-align: center; padding-top: 64px">
        <h2>No data available</h2>
        @if (displayedDateRange !== 'All Time') {
        <h4 class="text-empty-label mb-m">Why not check data collected in ...</h4>
        <button
          mat-flat-button
          style="background-color: #4682b4; color: white"
          (click)="onDateRangeShortcutClicked(shortcutFilter)"
        >
          {{ shortcutFilter.label }}
        </button>
        }
      </div>
      } }
      <app-table
        [hidden]="!isLoaded || dataSource.length === 0"
        [tableCols]="displayedColumns"
        [pageSize]="pageSize"
        [dataSource]="dataSource"
        [totalItems]="totalItems"
        (paginationChanged)="onPaginationChanged($event)"
      ></app-table>
      @if (!isLoaded) {
      <mat-spinner class="spinner-position"></mat-spinner>
      }
    </div>
  </mat-card>
</div>
